import PropTypes from 'prop-types';
import React, { Component } from 'react';
import IconButton from 'material-ui/IconButton';
import MenuItem from 'material-ui/MenuItem';
import * as Colors from 'material-ui/styles/colors';
import _ from 'lodash';
import {getSelectedItemsCount} from 'shared/selectors/templatesSelectors';
import DropDownMenu from 'material-ui/DropDownMenu';
import Subheader from 'material-ui/Subheader';
import ArrowDownward from 'material-ui/svg-icons/navigation/arrow-downward';
import CheckIcon from 'material-ui/svg-icons/navigation/check';

export default class VirtualizedListViewSortDropDownMenu extends Component {
  handleChangeSortField = (event, index, sortField) => this.props.onChange({sortField});
  handleToggleAscending = () => {
    const {sortAscending, onChange} = this.props;
    onChange({sortAscending: !sortAscending});
  };

  render() {
    const {sortAscending, sortField, sortFields} = this.props;
    return (
      <span style={{display: 'flex', alignItems: 'center', position: 'absolute', top: 2, right: 0}}>
        <span style={{color: Colors.grey500, position: 'relative', top: -3}}>
          Sort:
        </span>
        <DropDownMenu
          style={{fontWeight: 500, marginRight: -37, MozTop: 0, top: -5, marginLeft: -15, fontSize: 14}}
          iconStyle={{fill: Colors.grey700}}
          labelStyle={{textTransform: 'uppercase'}}
          value={sortField}
          onChange={this.handleChangeSortField}
          underlineStyle={{display: 'none'}}
        >
          <Subheader style={{lineHeight: '32px'}}>Sort By:</Subheader>
          {
            _.map(sortFields, ({label}, sortType) => {
              sortType = parseInt(sortType, 10);
              return <MenuItem key={sortType} value={sortType} primaryText={label} leftIcon={(sortType === (sortField)) ? <CheckIcon/> : <CheckIcon style={{opacity: 0}}/>} />;
            })
          }
        </DropDownMenu>
        <IconButton iconStyle={sortAscending ? {transform: 'rotate(180deg)'} : {}} onClick={this.handleToggleAscending}>
          <ArrowDownward />
        </IconButton>
      </span>
    );
  }
}

VirtualizedListViewSortDropDownMenu.propTypes = {
  onChange: PropTypes.func.isRequired,
};